import { render } from "./Backups.vue?vue&type=template&id=64f1717d"
import script from "./Backups.vue?vue&type=script&lang=ts"
export * from "./Backups.vue?vue&type=script&lang=ts"
script.render = render

export default script